import type {
  PlanRevisionTouchpointTelemetry,
  PlanRevisionTouchpointsTelemetry,
} from "../types";

import { isRecord } from "./utils";

export function sanitizeTouchpoints(
  value: unknown,
): PlanRevisionTouchpointsTelemetry | null {
  if (!isRecord(value) || !Array.isArray(value.touchpoints)) {
    return null;
  }
  const touchpoints = value.touchpoints
    .map((entry: unknown): PlanRevisionTouchpointTelemetry | null => {
      if (!isRecord(entry)) {
        return null;
      }
      const entryRecord = entry;
      if (
        typeof entryRecord.subtask_id !== "string" ||
        entryRecord.subtask_id.length === 0 ||
        typeof entryRecord.repository_slug !== "string" ||
        entryRecord.repository_slug.length === 0 ||
        typeof entryRecord.path !== "string" ||
        entryRecord.path.length === 0
      ) {
        return null;
      }
      const sanitized: PlanRevisionTouchpointTelemetry = {
        kind: entryRecord.kind === "folder" ? "folder" : "file",
        path: entryRecord.path,
        repository_slug: entryRecord.repository_slug,
        role:
          entryRecord.role === "create" ||
          entryRecord.role === "read" ||
          entryRecord.role === "verify"
            ? entryRecord.role
            : "modify",
        subtask_id: entryRecord.subtask_id,
      };
      if (typeof entryRecord.line_start === "number") {
        sanitized.line_start = entryRecord.line_start;
      }
      if (typeof entryRecord.line_end === "number") {
        sanitized.line_end = entryRecord.line_end;
      }
      if (typeof entryRecord.confidence === "number") {
        sanitized.confidence = entryRecord.confidence;
      }
      if (typeof entryRecord.note === "string") {
        sanitized.note = entryRecord.note;
      }
      return sanitized;
    })
    .filter((entry): entry is PlanRevisionTouchpointTelemetry =>
      Boolean(entry),
    );
  return touchpoints.length > 0 ? { touchpoints } : null;
}
